import { render, staticRenderFns } from "./ContactDetailLine.vue?vue&type=template&id=3954ae5a"
import script from "./ContactDetailLine.vue?vue&type=script&lang=js"
export * from "./ContactDetailLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports